<template>
  <Tooltip
    v-on-click-outside="closeTooltip"
    :triggers="[]"
    :shown="isOpen"
    :auto-hide="false"
    placement="right"
    @click="handlePropagation"
    @mouseenter="openTooltip"
    @focus="openTooltip"
    @mouseleave="delayedCloseTooltip"
    @blur="delayedCloseTooltip"
  >
    <span :class="$style.wrapper">
      <VdIcon
        store="fas"
        name="circle-info"
        size="xlarge"
        color="var(--vd-color-blue-default)"
        :class="$style.linkIcon"
        custom-size="14px"
      />
    </span>

    <template #popper>
      <div
        :class="$style.tooltipContent"
        @mouseenter="cancelCloseTooltip"
        @mouseleave="closeTooltip"
        @blur="closeTooltip"
        @focus="cancelCloseTooltip"
      >
        {{ tooltipText }}
        <br />
        <router-link :to="abTestLink" :class="$style.tooltipLink">Link to the AB test</router-link>
      </div>
    </template>
  </Tooltip>
</template>

<script setup>
import { vOnClickOutside } from "@vueuse/components";
import { Tooltip } from "floating-vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

const props = defineProps({
  abTestId: {
    type: String,
    required: true,
  },
  tooltipText: {
    type: String,
    default: "This offer is part of an AB test.",
  },
});

const route = useRoute();

const isOpen = ref(false);
const isMouseOverPopper = ref(false);
let closeTimeout = null;

const abTestLink = computed(() => {
  const { gameId } = route.params;
  const { versionId } = route.params;
  return `/games/${gameId}/${versionId}/abtests/${props.abTestId}/edit/cohorts`;
});

function handlePropagation(event) {
  event.stopPropagation();
}

function openTooltip() {
  isOpen.value = true;
  if (closeTimeout) {
    clearTimeout(closeTimeout);
    closeTimeout = null;
  }
}

function delayedCloseTooltip() {
  if (closeTimeout) {
    clearTimeout(closeTimeout);
  }
  closeTimeout = setTimeout(() => {
    if (!isMouseOverPopper.value) {
      closeTooltip();
    }
  }, 500);
}

function cancelCloseTooltip() {
  isMouseOverPopper.value = true;
}

function closeTooltip() {
  isOpen.value = false;
  if (closeTimeout) {
    clearTimeout(closeTimeout);
    closeTimeout = null;
  }
  isMouseOverPopper.value = false;
}
</script>

<style module>
.wrapper {
  border-radius: 15px;
  display: inline-flex;
  align-items: center;
  position: absolute;
  cursor: pointer;
}

.dropdownContent {
  color: white;
}

.tooltipLink a {
  color: white;
}

.linkIcon {
  position: absolute;
  left: -10px;
}
</style>
